import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { trackAddToWishlist, trackRemoveFromWishlist } from '../lib/analytics';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WishlistContext = createContext();
export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [wishlistIds, setWishlistIds] = useState([]);

  const fetchWishlist = useCallback(async () => {
    if (!isAuthenticated) { setWishlistIds([]); return; }
    try {
      const res = await axios.get(`${API}/wishlist`, { withCredentials: true });
      setWishlistIds(res.data.product_ids || []);
    } catch {
      setWishlistIds([]);
    }
  }, [isAuthenticated]);

  useEffect(() => { fetchWishlist(); }, [fetchWishlist]);

  const isInWishlist = useCallback((productId) => wishlistIds.includes(productId), [wishlistIds]);

  const toggleWishlist = useCallback(async (productId, product) => {
    if (!isAuthenticated) return false;
    try {
      if (wishlistIds.includes(productId)) {
        await axios.delete(`${API}/wishlist/${productId}`, { withCredentials: true });
        setWishlistIds(prev => prev.filter(id => id !== productId));
        trackRemoveFromWishlist(productId);
      } else {
        await axios.post(`${API}/wishlist/${productId}`, {}, { withCredentials: true });
        setWishlistIds(prev => [...prev, productId]);
        if (product) trackAddToWishlist(product);
      }
      return true;
    } catch {
      return false;
    }
  }, [isAuthenticated, wishlistIds]);

  const value = { wishlistIds, isInWishlist, toggleWishlist, fetchWishlist, count: wishlistIds.length };
  return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
};
